import { MAP_CONTENT_PROVIDER_GROUPS } from "@app/projects/network-assessment/multi-map-export/utils/mapContentOptions";
import { MultiMapExportAdequacyCombination } from "@app/projects/network-assessment/multi-map-export/interfaces";
import { MultiMapExportState } from "@app/projects/network-assessment/multi-map-export/state-management/multiMapExportStateManagement";

export const countSelectedCounties = (selections?: MultiMapExportState): number =>
  selections?.selectedCountyRegionSetIds?.length ?? 0;

export const countSelectedAdequacyStatuses = (selections?: MultiMapExportState): number =>
  selections?.selectedAdequacyOutcomes?.length ?? 0;

export const countSelectedProviderSources = (selections?: MultiMapExportState): number => {
  const selected = new Set(selections?.selectedMapContentProviderOptions ?? []);

  return MAP_CONTENT_PROVIDER_GROUPS.filter((group) => group.options.some((option) => selected.has(option.value))).length;
};

export const countSelectedSpecialties = (selections?: MultiMapExportState): number =>
  selections?.selectedSpecialtyGroupCodes?.length ?? 0;

/**
 * One map per analysed county/specialty combination that the user has selected on all three axes. Counted
 * from the real combinations rather than counties x specialties, because a combination the analysis never
 * produced, or whose outcome is not selected, generates no map.
 */
export const countMaps = (
  selections?: MultiMapExportState,
  combinations?: readonly MultiMapExportAdequacyCombination[],
): number => {
  const selectedCounties = new Set(selections?.selectedCountyRegionSetIds ?? []);
  const selectedSpecialties = new Set(selections?.selectedSpecialtyGroupCodes ?? []);
  const selectedOutcomes = new Set(selections?.selectedAdequacyOutcomes ?? []);

  if (!selectedCounties.size || !selectedSpecialties.size || !selectedOutcomes.size) return 0;

  return (combinations ?? []).filter((combination) => selectedCounties.has(combination.regionSetId)
    && selectedSpecialties.has(combination.specialtyGroupCode)
    && selectedOutcomes.has(combination.outcome)).length;
};

export const formatMapCount = (count: number): string => (count === 0 ? "—" : count.toLocaleString());

export const pluralize = (count: number, singular: string, plural: string): string => (count === 1 ? singular : plural);
